<template>
    <li class="mx-3 row handle">
        <div
            class="col-sm-11"
            :class="[isOpen ? 'input-table-shadow-disabled' : 'input-table-shadow']"
        >
            <table>
                <colgroup>
                    <col class="small" />
                    <col class="small" />
                    <col class="small" />
                    <col class="medium" />
                    <col class="medium" />
                    <col class="medium" />
                    <col class="medium" />
                    <col class="small" />
                    <col class="small" />
<!--                    <col class="medium" />-->
                    <col class="large" />
                    <col class="small" />
                </colgroup>
                <tr>
                    <td>
                        <input type="text" readonly :value="name" />
                    </td>
                    <td>
                        <input type="text" readonly :value="seat" />
                    </td>
                    <td @click.prevent="openReservation" class="pointer">
                        <input type="text" readonly :value="status" :class="statusColor" />
                    </td>
                    <td>
                        <input type="text" readonly :value="serviceName" />
                    </td>
                    <td>
                        <input type="text" class="form-control" readonly :value="originStation" />
                    </td>
                    <td>
                        <input type="text" class="form-control" readonly :value="destinationStation" />
                    </td>
                    <td>
                        <input type="text" readonly :value="mainTraveler" />
                    </td>
                    <td>
                        <input type="text" class="form-control" readonly :value="transfer" />
                    </td>
                    <td>
                        <input type="text" class="form-control" readonly :value="breakfast" />
                    </td>
<!--                    <td>-->
<!--                        <input type="text" class="form-control" readonly :value="phone" />-->
<!--                    </td>-->
                    <td>
                        <input type="text" class="form-control" readonly :value="email" />
                    </td>
                    <td>
                        <input type="text" class="form-control" readonly :value="remark" style="text-align: right;" />
                    </td>
                </tr>
            </table>
        </div>
        <div class="col-sm-1 d-flex align-items-center">
            <div
                v-if="!isOpen"
                class="col p-0"
                @click="rejectSeat"
            >
                <core-icon
                    style="cursor: pointer"
                    :iconName="$t('general.redo')"
                    iconColor="#bdbdbd"
                >
                    <icons-redo></icons-redo>
                </core-icon>
            </div>
            <div
                v-if="!isOpen && isParent"
                class="col px-1"
                @click="sendTicket"
            >
                <core-icon
                    style="cursor: pointer"
                    :iconName="$t('general.email')"
                    :iconColor="mailStatusColor"
                >
                    <icons-email></icons-email>
                </core-icon>
            </div>
            <div
                v-if="!isOpen && isParent"
                class="col p-0"
                @click="downloadTicket"
            >
                <core-icon
                    style="cursor: pointer"
                    :iconName="$t('general.download')"
                    iconColor="#bdbdbd"
                >
                    <icons-download></icons-download>
                </core-icon>
            </div>
        </div>
    </li>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    isOpen () {
      return !parseInt(this.item.reservationId)
    },
    isParent () {
      if (this.isOpen) {
        return false
      }
      return this.item.person && !this.item.person.personIdParent
    },
    name () {
      return this.item.rollingStockSeat.rollingStockCoupe.name
    },
    seat () {
      return this.item.rollingStockSeat.name.replace('Plaats ', '')
    },
    status () {
      return this.item.reservationId || 'Open'
    },
    mailStatusColor () {
      if (parseInt(this.item.emailed)) {
        return '#12b47d'
      } else {
        return '#bdbdbd'
      }
    },
    statusColor () {
      // Don't mind the name, it's the color that matters
      let statusClass = 'status-done'
      if (this.item.reservationId) {
        statusClass = 'status-todo'
      }
      if (this.item.occupied) {
        statusClass = 'status-actie'
      }
      return statusClass
    },
    serviceName () {
      return this.item.rollingStockSeat.rollingStockCoupe.service.name
    },
    mainTraveler () {
      let name = ''
      if (this.item.person && this.item.person.firstName) {
        name = this.item.person.firstName.charAt(0) + '. ' + this.item.person.lastName + ' (' + this.getAge(this.item.person.dateOfBirth) + ')'
      }
      return name
    },
    originStation () {
      let station = ''
      if (this.item.stationOrigin) {
        station = this.item.stationOrigin.name_NL
      }
      return station
    },
    destinationStation () {
      let station = ''
      if (this.item.stationDestination) {
        station = this.item.stationDestination.name_NL
      }
      return station
    },
    transfer () {
      return (parseInt(this.item.transfer) ? 'T' : '')
    },
    breakfast () {
      return (parseInt(this.item.breakfast) ? this.$t('services.inventory.breakfast') : '')
    },
    phone () {
      return ((this.item.phoneNumber) ? this.item.phoneNumber : this.item.mobileNumber)
    },
    email () {
      return ((this.item.person && this.item.person.email) ? this.item.person.email : '')
    },
    remark () {
      return this.item.remark
    }
  },
  methods: {
    openReservation () {
      this.$router.push({
        name: 'ViewBooking',
        params: {
          id: this.item.reservationId
        }
      })
    },
    getAge (date) {
      return this.$moment().diff(this.$moment(date, 'YYYY-MM-DD'), 'years')
    },
    rejectSeat () {
      this.$emit('rejectSeat', this.item)
    },
    downloadTicket () {
      this.$emit('downloadTicket', this.item)
    },
    sendTicket () {
      this.$emit('sendTicket', this.item)
    }
  }
}
</script>

<style scoped>
    table {
        width: 100%;
        table-layout: fixed;
    }
    .small {
        width: 7%;
    }
    .medium {
      width: 17%;
    }
    .large {
        width: 25%;
    }
    td {
      border: 0 !important;
      padding: 0 !important;
    }
    .pointer input {
      cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/inventory/booking/SeatListItem.vue